var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"video",attrs:{"width":"100%","height":"100%"}}),_c('button',{on:{"click":_vm.startScan}},[_vm._v("Start Scanning")]),(_vm.barcodeData)?_c('div',[_vm._v("Barcode detected: "+_vm._s(_vm.barcodeData))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }